import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const UserDropdownLanguagesList = styled.div``

export const UserDropdownLanguage = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 0px 13px 0;
  padding-inline-start: 15px;
  cursor: pointer;
  background: ${COLORS.primaryExtraLight};
  transition: all 0.3s;
  text-decoration: none;
  &:hover {
    background: ${COLORS.primaryLight};
    p {
      color: ${COLORS.secondaryDark};
    }
  }
`

export const UserDropdownLanguageFlag = styled.img`
  width: 24px;
  height: auto;
`
export const UserDropdownLanguageText = styled.p`
  color: ${COLORS.secondarySemiDark};
  font-size: 14px;
  font-weight: 500;
`
